function Banner() {
  return (
    <>
      <section className="banner-section">
        <div className="container">
          <div className="banner-content">
            <div className="banner-content__text">
              <h2>Économisez GROS en reservant votre véhicule chez librauto</h2>
              <p>
                Disponible <span>24/7</span> Support premium.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Banner;
